<template>
  <div class="main">
    <div class="overview" :class="{'box': !thirdValue.length}">
      <div class="title">第三方评价</div>
      <div class="d-flex justify-content-space-between align-items-center margin-bottom-8" v-for="(item, index) in thirdValue" :key="index">
        <div class="result">{{item.score}}分</div>
        <div class="result">共{{item.count}}条评论</div>
        <div class="result">{{item.source}}</div>
      </div>
    </div>
    <div class="touristsBox" :class="{'touristsBox':num!==0,'box':num == 0}">
      <div class="box_title">{{title}}({{num}}条)</div>
      <van-list
        ref="vanList"
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        :immediate-check="false"
        @load="onLoad"
        class="wrapper"
      >
          <div class="reject" v-for="(item,index) in activeList" :key="index">
            <div class="reject_item line_bottom">
              <div class="item_header">
                <div class="header_left">
                  <div class="haeder_img">
                    <img :src="addPrefix(item.userPortrait)" alt="" v-if="item.userPortrait">
                    <img src="../../../../assets/image/header.jpg" alt="" v-else>
                  </div>
                  <div class="header_name">
                    <p>{{item.userName}}</p>
                    <p>
                      <van-rate v-model="item.totalScore" allow-half void-icon="star" void-color="#CCCCCC" readonly count="5" size="10px" color="#36B374"/>
                    </p>
                  </div>
                </div>
                <div class="header_right">{{item.createDate|filt()}}</div>
              </div>
              <div class="item_content">
                <div class="content_tag" v-if="item.tags.length>0">
                  <div v-for="(item1,index1) in item.tags" :key="index1" class="tag line_border_hui">{{item1}}</div>
                </div>
                <!-- <div class="content_text" v-if="item.evaluateContent" :class="fold ? 'fold' : 'unfold'">{{item.evaluateContent}}</div> -->
                <div class="m-content overflow-line" id="J_description">{{item.evaluateContent}}</div>
                <div class="btn-more" v-if="item.evaluateContent && item.evaluateContent.length > 100" id="J_btnmore" @click="showmoreDesc($event)">全文</div>
                <div class="content_img">
                  <img
                    :src="addPrefix(item2)"
                    alt
                    v-for="(item2,index2) in  item.photoUrls"
                    :key="index2"
                    @click="showViewer(index2,$event,item.photoUrls)"
                  />
                </div>
                <div class="content_form">来源：{{item.source == 10 ? '诚信码' : '游云南App'}}</div>
              </div>
            </div>
          </div>
      </van-list>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/integrity'
    import moment from 'moment';
    export default {
        data () {
            return {
                value: 4.5,
                title: '游客评价',
                num: 0,
                finished: false,
                finishedText: '没有更多',
                loading: false,
                pageIndex: 0,
                enterpriseId: '',
                activeList: [],
                photoUrls: [
                    { img: require('../../../../assets/image/testPic.jpg') },
                    { img: require('../../../../assets/image/testPic.jpg') },
                    { img: require('../../../../assets/image/testPic.jpg') },
                    { img: require('../../../../assets/image/testPic.jpg') }
                ],
                isShowMore: false,
                isDescStatus: true,
                introduce: '',
                thirdValue: []
            }
        },
        created () {
            this.getId();
        },
        methods: {
          thirdEvaluate(enterpriseId) {
            api.thirdEvaluate({
              enterpriseId
            }).then (res => {
              thirdValue = res.data;
            })
          },
            getId () {
                this.enterpriseId = this.$route.query.id || this.$route.params.id;
                this.getTousitList(this.enterpriseId);
                this.thirdEvaluate(this.enterpriseId);
            },
            // 列表
            getTousitList (val) {
                this.activeList = [];
                this.pageIndex = 1;
                let data = {
                    enterpriseId: val,
                    pageIndex: this.pageIndex,
                    pageSize: '10'
                }
                api.evaluatePage(data).then(res => {
                    this.loading = false; // 加载参数
                    if (res.data.list.length > 0) { // 有数据
                        this.activeList = res.data.list;
                        this.num = res.data.pageination.total;
                        if (this.activeList.length > 0) {
                            this.activeList.map((item, index) => {
                                console.log(item);
                                this.$set(item, 'totalScore', item.totalScore / 2)
                            })
                        }
                        console.log(this.activeList);
                        if (res.data.list.length === res.data.pageination.total) { // 已加载完了
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                        this.isNolist = false;
                    } else {
                        this.finished = true;
                        this.loading = false;
                        this.isNolist = true;
                        this.finishedText = '';
                    }
                })
            },
            getMore () {
                let data = {
                    enterpriseId: this.enterpriseId,
                    pageIndex: this.pageIndex,
                    pageSize: '10'
                }
                api.evaluatePage(data).then(res => {
                    if (res.data.list.length > 0) { // 有数据
                        this.proList = this.activeList.concat(res.data.list);
                        if (this.proList.length === res.data.pageination.total) {
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                    }
                });
            },
            // 加载更多
            onLoad () {
                this.pageIndex++;
                this.getMore();
            },
            // 收起全文切换
            showmoreDesc (e) {
                let el = e.currentTarget;
                el.previousElementSibling.classList[!this.isDescStatus ? 'add' : 'remove']('overflow-line');
                el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
                el.innerHTML = !this.isDescStatus ? '全文' : '收起';
                this.isDescStatus = !this.isDescStatus;
                this.isShowMore = true;
            },
            // 图片预览
            showViewer (index, event, imgList) {
                let url = imgList.map(item => {
                    return this.addPrefix(item);
                })
                // this.$ImagePreview({ images: url, startPosition: index, closeOnPopstate: true });
                this.$router.push({
                  path: '/complaint/imagesView',
                  query: {
                    imageList:url|| [],
                    index
                  },
                })

            },
            // 添加域名
            addPrefix (url) {
                let str = RegExp('http') || RegExp('https');
                let newUrl;
                str.test(url) ? newUrl = url : newUrl = 'https://' + url;
                return newUrl
            }
        },
        
        filters: {
            filt (value) {
                return moment(value).format('YYYY-MM-DD');
            }
        }
    }
</script>

<style lang="less" scoped>
.d-flex {
  display: flex;
  align-items: center;
}
.justify-content-space-between {
  justify-content: space-between
}
.align-items-center {
  align-items: center
}
.margin-bottom-8 {
  margin-bottom: 8px;
  &:last-of-type {
    margin-bottom: 0;
  }
}
.main {
  .overview {
    background: #FFFFFF;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding: 12px;
    .title {
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .result {
      color: #666666;
      font-size: 12px;
    }
  }
  margin-top: 12px;
  .touristsBox {
    width:100;
    height:100%;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    padding: 0 13px 18px 16px;
    .box_title {
      width:105px;
      height:14px;
      font-size:14px;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:14px;
      padding: 12px 0px;
    }
    .wrapper {
      .reject {
        .reject_item {
          padding: 16px 0;
          .item_header {
            display: flex;
            justify-content: space-between;
            .header_left {
              display: flex;
              .haeder_img {
                width: 30px;
                height: 30px;
                margin-right: 7px;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                  object-fit: cover;
                }
              }
              .header_name {
                font-size:14px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:bold;
                color:#333333;
                line-height:14px;
                p:nth-child(2) {
                  margin-top: 4px;
                }
              }
            }
            .header_right {
              font-size:12px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:#666666;
              line-height:12px;
            }
          }
          .item_content {
            padding-left: 37px;
            .content_tag {
              display: flex;
              margin-top: 8px;
              .tag {
                margin-right: 4px;
                padding: 5px 4px;
                font-size:10px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:12px;
              }
            }
            .content_text {
              font-size:14px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(51,51,51,1);
              line-height:22px;
              word-break: break-all;
              margin-top: 8px;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .m-content {
              font-size:14px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(51,51,51,1);
              line-height:22px;
              word-break: break-all;
              margin-top: 8px;
              overflow: hidden;
              text-overflow: ellipsis;
              &.overflow-line {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 5;
                overflow: hidden;
              }
            }

            .btn-more {
              color: #36B277;
              position: relative;
              font-size: 14px;
              margin-top: 8px;
              // padding-right: rc(33);

              &.more-collapse {

                &::after,
                &::before {
                  top: 2px;
                  transform: rotate(180deg);
                }

                &::before {
                  top: 4px;
                }
              }

              &::after,
              &::before {
                width: 0;
                height: 0;
                content: '';
                position: absolute;
                right: 0;
                top: 7px;
                border: rc(12) solid transparent;
              }

              &::after {
                border-top-color: #5383E7;
                z-index: 1;
              }

              &::before {
                border-top-color: #1c2239;
                z-index: 2;
                top: 5px;
              }

            }
            .content_img {
              width:100%;
              height:100%;
              display: flex;
              flex-wrap: wrap;
              margin-top: 8px;
              img {
                width: 88px;
                height: 88px;
                border-radius:4px;
                margin-right: 8px;
                margin-bottom: 10px;
              }
              img:nth-child(3n+3) {
                width: 88px;
                height: 88px;
                border-radius:4px;
                margin-right: 0;
                margin-bottom: 10px;
              }
            }
            .content_form {
              font-size:12px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(153,153,153,1);
              line-height:12px;
              text-align: right;
              margin-top: 4px;
            }
          }
        }
      }
    }
  }
  .box {
    display: none;
  }
  // .m-content {
  //   &.overflow-line {
  //     display: -webkit-box;
  //     -webkit-box-orient: vertical;
  //     -webkit-line-clamp: 3;
  //     overflow: hidden;
  //   }
  // }

  // .btn-more {
  //   color: #fff;
  //   float: right;
  //   color: #5383E7;
  //   position: relative;
  //   margin-top: rc(5);
  //   padding-right: rc(33);

  //   &.more-collapse {

  //     &::after,
  //     &::before {
  //       top: 2px;
  //       transform: rotate(180deg);
  //     }

  //     &::before {
  //       top: 4px;
  //     }
  //   }

  //   &::after,
  //   &::before {
  //     width: 0;
  //     height: 0;
  //     content: '';
  //     position: absolute;
  //     right: 0;
  //     top: 7px;
  //     border: rc(12) solid transparent;
  //   }

  //   &::after {
  //     border-top-color: #5383E7;
  //     z-index: 1;
  //   }

  //   &::before {
  //     border-top-color: #1c2239;
  //     z-index: 2;
  //     top: 5px;
  //   }

  // }
}
</style>
